/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MEDIA_TYPE, VIDEO_TYPE } from 'store/modules/base/media/constants';
import {
  getLocalParticipant,
  getVideoDeviceParticipants
} from 'store/modules/base/participants/functions';
import { connect } from 'store/modules/base/redux/functions';
import {
  getVideoTrackByParticipant,
  isLocalTrackMuted
} from 'store/modules/base/tracks/functions';
import { setColorAlpha } from 'store/modules/base/util/helpers';
import { sendSingleKnockMessage } from 'store/modules/chat/actions';
import { getLargeVideoParticipant } from 'store/modules/large-video/functions';
import { fetchUserInfo } from 'store/modules/login/actions';
import { setSeeWhatIsBeingShared } from 'store/modules/large-video/actions';
import { shouldDisplayTileView } from 'store/modules/video-layout/functions';
import { getActiveParticipantsIds } from 'store/modules/filmstrip/functions';
import { Block } from '@mui/icons-material';
import VideoLayout from 'util/UI/videolayout/VideoLayout';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import KnockThemButton from '../Toolbox/KnockThemButton';
import JoinRemoteAudio from '../Toolbox/JoinRemoteAudio';
import ScreenSharePlaceholder from './ScreenSharePlaceholder';
import ParticipantInfo from './ParticipantInfo';

// Hack to detect Spot.
const SPOT_DISPLAY_NAME = 'Meeting Room';

/** .
 * Implements a React {@link Component} which represents the large video (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
class LargeVideo extends Component {
  /**
   * Constructor of the component.
   *
   * @inheritdoc
   */
  constructor(props) {
    super(props);

    this._containerRef = React.createRef();
    this._wrapperRef = React.createRef();

    this._clearTapTimeout = this._clearTapTimeout.bind(this);
    this._onDoubleTap = this._onDoubleTap.bind(this);
  }

  /**
   * Implements {@code Component#componentDidMount}.
   *
   * @inheritdoc
   */
  componentDidMount() {
    this._wrapperRef?.current?.addEventListener('dblclick', () => {
      this.props.dispatch(sendSingleKnockMessage());
    });
  }

  /**
   * Implements {@code Component#componentDidUpdate}.
   *
   * @inheritdoc
   */
  componentDidUpdate(prevProps) {
    const { _isScreenSharing, _seeWhatIsBeingShared, _largeVideoParticipant } =
      this.props;

    if (prevProps._isScreenSharing !== _isScreenSharing && !_isScreenSharing) {
      this.props.dispatch(setSeeWhatIsBeingShared(false));
    }

    if (_isScreenSharing && _seeWhatIsBeingShared) {
      VideoLayout.updateLargeVideo(_largeVideoParticipant?.id, true, true);
    }

    if (
      _largeVideoParticipant &&
      _largeVideoParticipant?.customUserid &&
      _largeVideoParticipant?.customUserid !== 'off' &&
      prevProps._largeVideoParticipant?.customUserid !==
        _largeVideoParticipant?.customUserid
    ) {
      this.props.dispatch(fetchUserInfo(_largeVideoParticipant.customUserid));
    }
  }

  /**
   * Implements React's {@link Component#render()}.
   *
   * @inheritdoc
   * @returns {React$Element}
   */
  render() {
    const {
      _displayScreenSharingPlaceholder,
      _noAutoPlayVideo,
      _showDominantSpeakerBadge,
      _largeVideoParticipant,
      _isVisible,
      _isJoinedAudio,
      _userProfileOptions,
      _blurContent,
      localParticipantId
    } = this.props;
    const style = this._getCustomStyles();
    return (
      <div
        className="videocontainer"
        id="largeVideoContainer"
        onDoubleClick={this._onDoubleTap}
        ref={this._containerRef}
        style={{ ...style, display: _isVisible ? 'block' : 'none' }}>
        <div id="etherpad" />
        <div id="dominantSpeaker">
          <div className="dynamic-shadow" />
          <div id="dominantSpeakerAvatarContainer" />
        </div>
        <div id="remotePresenceMessage" />
        <span id="remoteConnectionMessage" />
        <div id="largeVideoElementsContainer">
          <div id="largeVideoBackgroundContainer" />
          {/*
           * FIXME: the architecture of elements related to the large
           * video and the naming. The background is not part of
           * largeVideoWrapper because we are controlling the size of
           * the video through largeVideoWrapper. That's why we need
           * another container for the background and the
           * largeVideoWrapper in order to hide/show them.
           */}
          <div id="largeVideoWrapper" ref={this._wrapperRef} role="figure">
            {_displayScreenSharingPlaceholder ? (
              <ScreenSharePlaceholder />
            ) : (
              <video
                className={
                  _blurContent === localParticipantId ? 'blurLargeVideo' : null
                }
                autoPlay={!_noAutoPlayVideo}
                id="largeVideo"
                muted={true}
                preload="auto"
                playsInline={true} /* for Safari on iOS to work */
              />
            )}
          </div>
        </div>
        {_isJoinedAudio && (
          <div className="nonAudioContainer">
            <div className="nonAudioText">
              the far site microphone and speaker are off
            </div>
            <div className="nonAudioButtons">
              <KnockThemButton isDesktop={true} />
              <JoinRemoteAudio
                _disabled={_userProfileOptions?.allowRemoteAudioControl !== 1}
                isDesktop={true}
              />
            </div>
          </div>
        )}
        {_showDominantSpeakerBadge && (
          <ParticipantInfo largeVideoParticipant={_largeVideoParticipant} />
        )}
        {_blurContent === localParticipantId && (
          <div className="nonAudioContainer">
            <Block style={{ width: '5rem', height: '5rem', fill: 'white' }} />
          </div>
        )}
      </div>
    );
  }

  /**
   * Clears the '_tappedTimout'.
   *
   * @private
   * @returns {void}
   */
  _clearTapTimeout() {
    clearTimeout(this._tappedTimeout);
    this._tappedTimeout = undefined;
  }

  /**
   * Creates the custom styles object.
   *
   * @private
   * @returns {Object}
   */
  _getCustomStyles() {
    const styles = {};
    const { _customBackgroundColor, _customBackgroundImageUrl } = this.props;

    styles.pointerEvents = 'all !important';
    styles.backgroundColor =
      _customBackgroundColor || interfaceConfig.DEFAULT_BACKGROUND;

    if (this.props._backgroundAlpha !== undefined) {
      const alphaColor = setColorAlpha(
        styles.backgroundColor,
        this.props._backgroundAlpha
      );

      styles.backgroundColor = alphaColor;
    }

    if (_customBackgroundImageUrl) {
      styles.backgroundImage = `url(${_customBackgroundImageUrl})`;
      styles.backgroundSize = 'cover';
    }
    return styles;
  }

  /**
   * Sets view to tile view on double tap.
   *
   * @param {Object} e - The event.
   * @private
   * @returns {void}
   */
  _onDoubleTap(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this._tappedTimeout) {
      this._clearTapTimeout();
    } else {
      this._tappedTimeout = setTimeout(this._clearTapTimeout, 300);
    }
  }
}

LargeVideo.propTypes = {
  dispatch: PropTypes.func,
  localParticipantId: PropTypes.string,
  _backgroundAlpha: PropTypes.number,
  _customBackgroundColor: PropTypes.string,
  _customBackgroundImageUrl: PropTypes.string,
  _blurContent: PropTypes.string,
  _displayScreenSharingPlaceholder: PropTypes.bool,
  _isScreenSharing: PropTypes.bool,
  _largeVideoParticipant: PropTypes.object,
  _userProfileOptions: PropTypes.object,
  _noAutoPlayVideo: PropTypes.bool,
  _seeWhatIsBeingShared: PropTypes.bool,
  _showDominantSpeakerBadge: PropTypes.bool,
  _shouldDisplayTileView: PropTypes.bool,
  _isVisible: PropTypes.bool,
  _isJoinedAudio: PropTypes.bool
};

/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
  const testingConfig = state['features/base/config'].testing;
  const isVideoOnly = state['features/settings'].videoOnly;
  const profiles = state['features/login'].profiles;
  const blurContentId = state['features/large-video'].blurContentWarning;
  const { backgroundColor, backgroundImageUrl } =
    state['features/dynamic-branding'];
  const { defaultLocalDisplayName, hideDominantSpeakerBadge } =
    state['features/base/config'];
  const { seeWhatIsBeingShared } = state['features/large-video'];
  const activeParticipants = getActiveParticipantsIds(state);
  const localParticipantId = getLocalParticipant(state)?.id;
  const largeVideoParticipant = getLargeVideoParticipant(state);
  const deviceParticipants = getVideoDeviceParticipants(state);
  const videoTrack = getVideoTrackByParticipant(state, largeVideoParticipant);
  const isLocalScreenshareOnLargeVideo =
    largeVideoParticipant?.id?.includes(localParticipantId) &&
    videoTrack?.videoType === VIDEO_TYPE.DESKTOP;
  const isOnSpot = defaultLocalDisplayName === SPOT_DISPLAY_NAME;
  const _videoMuted = isLocalTrackMuted(
    state['features/base/tracks'],
    MEDIA_TYPE.VIDEO
  );
  const _shouldDisplayTileView = shouldDisplayTileView(state);
  const isVisible =
    !_videoMuted &&
    !_shouldDisplayTileView &&
    largeVideoParticipant?.id &&
    (activeParticipants.length <= 1 || deviceParticipants > 0);

  return {
    localParticipantId,
    _shouldDisplayTileView,
    _backgroundAlpha: state['features/base/config'].backgroundAlpha,
    _customBackgroundColor: backgroundColor,
    _customBackgroundImageUrl: backgroundImageUrl,
    _displayScreenSharingPlaceholder:
      isLocalScreenshareOnLargeVideo && !seeWhatIsBeingShared && !isOnSpot,
    _isScreenSharing: isLocalScreenshareOnLargeVideo,
    _largeVideoParticipant: largeVideoParticipant,
    _isJoinedAudio:
      !isVideoOnly && largeVideoParticipant?.customIsAudioAvailable !== 'on',
    _userProfileOptions:
      profiles &&
      profiles[largeVideoParticipant?.customUserid] &&
      profiles[largeVideoParticipant?.customUserid].device?.options,
    _noAutoPlayVideo: testingConfig?.noAutoPlayVideo,
    _seeWhatIsBeingShared: seeWhatIsBeingShared,
    _showDominantSpeakerBadge: !hideDominantSpeakerBadge && ownProps.visible,
    _blurContent: blurContentId,
    _isVisible: isVisible
  };
}

export default React.memo(connect(_mapStateToProps)(withBoundary(LargeVideo)));
